export default "__VITE_ASSET__Broa7vjI__"